import React, { FC, useState } from 'react';

import useTranslation from '@app/hooks/use-translation';

import Input from '../input';

interface SearchBarPropsType {
  onChange?(value: string): void;
  onSearch?(value: string): void;
}

const SearchBar: FC<SearchBarPropsType> = (props) => {
  const { onChange, onSearch } = props;
  const { t } = useTranslation('components.searchBar');
  const [input, setInput] = useState('');

  function onChangeInput(event: React.ChangeEvent<HTMLInputElement, Element>) {
    const value = event.target.value;
    setInput(value);
    onChange?.(value);
  }

  function onSearchIconClick() {
    onSearch?.(input);
  }

  return (
    <div className="w-full px-4">
      <Input
        placeholder={t('placeholder')}
        defaultValue={input}
        onChange={onChangeInput}
        icon="SearchIcon"
        onClick={onSearchIconClick}
      />
    </div>
  );
};

export default SearchBar;
